import { useEffect, useRef } from "react";
import { debounceTime, Subject } from "rxjs";

export const useScroll$ = (container: any) => {
  const scroll$Ref = useRef(new Subject());
  const obs$ = useRef(scroll$Ref.current.pipe(debounceTime(600)));
  useEffect(() => {
    if (container) {
      const scrollFunction = () => {
        let scrollTop = container.scrollTop,
          scrollHeight = container.scrollHeight,
          viewportHeight = container.clientHeight;
        scroll$Ref.current.next({ scrollTop, scrollHeight, viewportHeight });
      };
      container.addEventListener("scroll", scrollFunction);

      return () => {
        container.removeEventListener("scroll", scrollFunction);
      };
    } else {
      const scrollFunction = () => {
        let docBody = document.body,
          docElement = document.documentElement,
          scrollTop = window.pageYOffset || document.documentElement.scrollTop,
          winHeight = docElement.clientHeight,
          docHeight = Math.max(
            docBody.scrollHeight,
            docBody.offsetHeight,
            winHeight,
            docElement.scrollHeight,
            docElement.offsetHeight
          );

        scroll$Ref.current.next({
          scrollTop,
          scrollHeight: docHeight,
          viewportHeight: winHeight,
        });
      };

      window.addEventListener("scroll", scrollFunction);
    }
  }, [container, scroll$Ref]);
  return obs$.current;
};
